import { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { FaCalendar, FaCalendarDay, FaClock, FaWifi } from "react-icons/fa";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { useSuperState } from "helpers/hooks";
import { useApp } from "common/context";
import { SnapshotRowWidget } from "pages/dashboard/main/widgets/snapshot_row/SnapshotRowWidget";

export const SnapshotRow = () => {

    const { api } = useApp();

    const [state, setState] = useSuperState({
        error: null,
        loading: true,
        session_count: null,
        session_count_24hrs: null,
        session_count_today: null,
        minutes_today: null
    });
    const { loading, session_count, session_count_24hrs, session_count_today, minutes_today } = state;

    const fetchStats = async () => {

        try {

            const { session_count, session_count_24hrs, session_count_today, minutes_today } = await api.get(`/api/appstream/stats/basics`);

            setState({
                session_count,
                session_count_24hrs,
                session_count_today,
                minutes_today
            });

        } catch (e){

            const error = e?.err || e?.message || e;
            setState({ error });

        }

    };

    useEffect(() => {

        let interval;

        (async () => {

            await fetchStats();

            setState({ loading: false });

            interval = setInterval(fetchStats, 10000);

        })();

        return () => {

            clearInterval(interval);

        };

    }, []);

    return (
        <>
            <h3 className="text-secondary">
                <FormattedMessage
                    id="label.live_snapshot"
                    defaultMessage="Live Snapshot"
                />
            </h3>

            <Row>
                <Col lg={3} className="mb-2">
                    <SnapshotRowWidget loading={loading}>
                        <div className="me-3">
                            <FaWifi size={30}/>
                        </div>
                        <div>
                            <FormattedMessage
                                id="label.live_sessions"
                                defaultMessage="Live Sessions"
                            />
                            <h3>
                                <FormattedNumber value={session_count}/>
                            </h3>
                        </div>
                    </SnapshotRowWidget>
                </Col>

                <Col lg={3} className="mb-2">
                    <SnapshotRowWidget loading={loading}>
                        <div className="me-3">
                            <FaCalendar size={30}/>
                        </div>
                        <div>
                            <FormattedMessage
                                id="label.sessions_past_24hr"
                                defaultMessage="Sessions Past 24hr"
                            />
                            <h3>
                                <FormattedNumber value={session_count_24hrs}/>
                            </h3>
                        </div>
                    </SnapshotRowWidget>
                </Col>

                <Col lg={3} className="mb-2">
                    <SnapshotRowWidget loading={loading}>
                        <div className="me-3">
                            <FaCalendarDay size={30}/>
                        </div>
                        <div>
                            <FormattedMessage
                                id="label.sessions_today"
                                defaultMessage="Sessions Today"
                            />
                            <h3>
                                <FormattedNumber value={session_count_today}/>
                            </h3>
                        </div>
                    </SnapshotRowWidget>
                </Col>

                <Col lg={3}>
                    <SnapshotRowWidget loading={loading}>
                        <div className="me-3">
                            <FaClock size={30}/>
                        </div>
                        <div>
                            <FormattedMessage
                                id="label.minutes_today"
                                defaultMessage="Minutes Today"
                            />
                            <h3>
                                <FormattedNumber value={minutes_today}/>
                            </h3>
                        </div>
                    </SnapshotRowWidget>
                </Col>
            </Row>
        </>
    );

};